import { intelApi } from '@/api/IntelApi'
import { useStore } from '@/store'
import Constants from 'expo-constants'
import * as Crypto from 'expo-crypto'
import * as Device from 'expo-device'
import * as Updates from 'expo-updates'
import { isNil } from 'ramda'
import { Platform } from 'react-native'
import { InteractionMedium, InteractionType } from './index.types'
import type {
	Interaction,
	InteractionClickDetails,
	InteractionDetails,
	InteractionDevice,
	InteractionEventDetails,
	InteractionViewDetails,
} from './index.types'

export class AnalyticsManager {
	trackView(pathname: string) {
		const details: InteractionViewDetails = {
			pageUrl: pathname,
			actionType: InteractionType.VIEW,
			medium: InteractionMedium.PATIENT_APP,
		}

		const interactionEvent = this._resolveEventWithDetails(details)
		this._recordInteraction(interactionEvent)
	}

	trackEvent(eventName: string, metadata?: Record<string, string | number | boolean>) {
		const details: InteractionEventDetails = {
			eventName,
			actionType: InteractionType.EVENT,
			medium: InteractionMedium.PATIENT_APP,
			properties: metadata ?? {},
		}

		const interactionEvent = this._resolveEventWithDetails(details)
		this._recordInteraction(interactionEvent)
	}

	trackClick(clickName: string, metadata?: Record<string, string | number | boolean>) {
		const details: InteractionClickDetails = {
			clickName,
			actionType: InteractionType.CLICK,
			medium: InteractionMedium.PATIENT_APP,
			properties: metadata || {},
		}

		const interactionEvent = this._resolveEventWithDetails(details)
		this._recordInteraction(interactionEvent)
	}

	private _resolveDeviceMetadata = (): InteractionDevice => {
		return {
			platform: Device.osName,
			deviceType: Device.deviceType?.toString(),
			isRealDevice: Device.isDevice,
			deviceModel: Device.modelName,
			deviceVersion: Device.osVersion,
			appVersion: Constants.expoConfig?.version,
			appPlatform: Platform.OS,
			easVersion: Updates.updateId,
		}
	}

	private _resolveEventWithDetails = (details: InteractionDetails): Interaction => {
		const utcTime = new Date().toISOString()
		const authUserId = useStore.getState().authUserId

		return {
			appId: Constants.expoConfig?.slug,
			userId: !isNil(authUserId) ? Number.parseInt(authUserId) : undefined,
			eventId: Crypto.randomUUID(),
			anonymousId: useStore.getState().anonymousId,
			details: details,
			identity: {
				email: useStore.getState().loginEmail,
			},
			ad: {},
			utms: {},
			referral: {},
			device: this._resolveDeviceMetadata(),
			createdAt: utcTime,
			occurredAt: utcTime,
		}
	}

	private _recordInteraction = (interaction: Interaction) => {
		intelApi.sendInteraction(interaction)
	}
}

export const analytics = new AnalyticsManager()
